package ui.screens.section.wishesandgift

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import models.Wish
import ui.composables.WarningDialog
import ui.theme.ColorScheme
import ui.theme.EmojiFont
import kotlin.random.Random

@Composable
fun WishInput(name: String, onClickListener: (Wish) -> Unit) {
    var gift by remember {
        mutableStateOf(TextFieldValue(""))
    }
    var message by remember { mutableStateOf(TextFieldValue("")) }
    var isCheckedBox by remember { mutableStateOf(true) }
    var nameField by remember { mutableStateOf(TextFieldValue("")) }
    var showDialog by remember { mutableStateOf(false) }


    OutlinedTextField(
        value = nameField,
        onValueChange = { nameField = it },
        label = { Text("Nama") },
        textStyle = MaterialTheme.typography.labelLarge.copy(
            fontSize = 16.sp,
            letterSpacing = 0.sp,
            fontWeight = FontWeight.Normal,
            fontFamily = EmojiFont
        ),
        modifier = Modifier.fillMaxWidth(),
        singleLine = true
    )

    Spacer(Modifier.height(8.dp))

    // Input Form
    OutlinedTextField(
        value = message,
        onValueChange = { newValue ->
            message = newValue
        },
        label = { Text("Ucapan") },
        modifier = Modifier.fillMaxWidth(),
        minLines = 4,
        maxLines = 4,
        keyboardOptions = KeyboardOptions(
            keyboardType = KeyboardType.Text
        ),
        textStyle = MaterialTheme.typography.labelLarge.copy(
            fontSize = 16.sp,
            letterSpacing = 0.sp,
            fontWeight = FontWeight.Normal,
            fontFamily = EmojiFont
        )
    )

    Row(
        Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Start,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Checkbox(
            checked = isCheckedBox,
            onCheckedChange = { isCheckedBox = it }
        )
        Column {
            Text("Tampilkan ucapan", fontSize = 14.sp)
            Text(
                "*Hapus centang jika ucapanmu tidak ingin tampil di daftar ucapan",
                fontSize = 12.sp,
                color = Color.Red,
                textAlign = TextAlign.Start,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }

    Spacer(Modifier.height(8.dp))

    OutlinedTextField(
        value = gift,
        onValueChange = { newValue ->
            // Ambil hanya digit
            val digits = newValue.text.filter { it.isDigit() }
            // Hilangkan leading zero (00100 -> 100)
            val normalized = if (digits.isBlank()) {
                ""
            } else {
                digits.trimStart('0').ifEmpty { "0" }
            }
            val formatted = if (normalized.isEmpty()) {
                ""
            } else {
                formatCurrency(normalized)
            }
            // Paksa cursor di akhir
            gift = TextFieldValue(
                text = formatted,
                selection = TextRange(formatted.length)
            )
        },
        label = { Text("Kado (Rp) - Optional") },
        modifier = Modifier.fillMaxWidth(),
        singleLine = true,
        keyboardOptions = KeyboardOptions(
            keyboardType = KeyboardType.Number
        ),
        textStyle = MaterialTheme.typography.labelLarge.copy(
            fontSize = 16.sp,
            letterSpacing = 0.sp,
            fontWeight = FontWeight.Normal
        )
    )

    Spacer(Modifier.height(6.dp))

    Text(
        "Notes:",
        fontSize = 16.sp,
        color = Color.Red,
        textAlign = TextAlign.Start,
        modifier = Modifier.fillMaxWidth()
    )
    Text(
        "*Isi kolom Kado jika ingin memberikan kado cashless",
        fontSize = 14.sp,
        color = Color.Red,
        textAlign = TextAlign.Start,
        modifier = Modifier.fillMaxWidth()
    )
    Text(
        "*Nominal kado tidak akan kami tampilkan",
        fontSize = 14.sp,
        color = Color.Red,
        textAlign = TextAlign.Start,
        modifier = Modifier.fillMaxWidth()
    )

    Spacer(Modifier.height(16.dp))

    Button(
        onClick = {
            if (message.text.isNotBlank() && nameField.text.isNotBlank()) {
                val finalGifted = if (gift.text.isBlank() || gift.text == "0") {
                    "0"
                } else {
                    "Rp${formatCurrency(addRandomThreeDigits(gift.text.trim()))}"
                }
                val wish = if (name.contains("Tim ")) {
                    val finalName = nameField.text.trim() + " " + name.replace("Tim ", "")
                    Wish(
                        name = finalName,
                        from = name,
                        message = message.text.trim(),
                        isShow = isCheckedBox,
                        gift = finalGifted,
                        createdAt = 0
                    )
                } else {
                    Wish(
                        name = nameField.text.trim(),
                        from = name,
                        message = message.text.trim(),
                        isShow = isCheckedBox,
                        gift = finalGifted,
                        createdAt = 0,
                    )
                }
                onClickListener(wish)
                nameField = TextFieldValue("")
                gift = TextFieldValue("")
                message = TextFieldValue("")
            } else {
                showDialog = true
            }
        },
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(containerColor = ColorScheme.secondary)
    ) {
        Text("Kirim", color = Color.White)
    }

    WarningDialog(
        show = showDialog,
        onDismiss = { showDialog = false }
    )
}

fun addRandomThreeDigits(value: String): String {
    val number = value.replace(".", "").toInt()
    val randomThree = Random.nextInt(0, 1000) // angka acak 0–999
    val finalNumber = number + randomThree
    return finalNumber.toString()
}

fun formatCurrency(value: String): String {
    if (value.isEmpty()) return ""
    val normalized = value.trimStart('0').ifEmpty { "0" }
    val result = StringBuilder()
    var counter = 0
    for (i in normalized.length - 1 downTo 0) {
        result.append(normalized[i])
        counter++
        if (counter % 3 == 0 && i != 0) {
            result.append('.')
        }
    }
    return result.reverse().toString()
}